
export const PERIODS = [
    'total', 'month', 'week', 'day'
]
